/* 
 * AutoClickerController.js
 * Created on 7-dec-2016
 * @author Swen Meeuwes for &ranj
 */

import AbstractDebugView from "../../../core/view/AbstractDebugView";
import ToggleButton from "../../../core/view/ToggleButton";
import ToggleButtonEvent from "../../../core/view/ToggleButtonEvent";
import gremlins from "gremlins-ts";

export default class AutoClickerController extends AbstractDebugView {
    constructor(assetLibrary, stageManager) {
        const keycode = assetLibrary.getAsset("debugtools_config").keyBindings.autoClicker.charCodeAt(0);
        super(keycode, "ranj/debug/modules/autoclicker/view/AutoClickerGUI.html", "Auto Clicker", "width=240,height=205");

        this._stageManager = stageManager;

        this._isEnabled = false;

        this._gremlinHorde;
        this._unleashButton;

        console.info("[Auto Clicker] Init succes!");
    }

    onLoad() {
        super.onLoad();
        this._gremlinHorde = this._createGremlineHorde();
        this._setupButtons();
    }

    _setupButtons() {
        this._unleashButton = new ToggleButton(this._gui.document.getElementById("unleashButton"));
        this._unleashButton.setToggleState(this._isEnabled);

        this._handleUnleashButtonBound = this._handleUnleashButton.bind(this);
        this._unleashButton.addEventListener(ToggleButtonEvent.CLICK, this._handleUnleashButtonBound);
    }

    _handleUnleashButton() {
        if (this._unleashButton.isToggled())
            this._gremlinHorde.unleash();
        else
            this._gremlinHorde.stop();

        this._isEnabled ? this._isEnabled = false : this._isEnabled = true;
    }

    _createGremlineHorde() {
        const stages = this._stageManager.getStages();

        var gremlinHorde = gremlins.createHorde().gremlin(gremlins.species.clicker().clickTypes(['click']).showAction((x, y) => {
            // Should call prototype showAction
            const mouseEvent = new MouseEvent("click", false, false, x, y, 0, -1, true, x, y); //( type  bubbles  cancelable  stageX  stageY  nativeEvent  pointerID  primary  rawX  rawY  relatedTarget )
            stages.mainGameCanvas.stage.dispatchEvent(mouseEvent);
            const c = stages.mainGameCanvas.getObjectUnderPoint(x, y, 0);
            if (c) {
                c.dispatchEvent(mouseEvent);
                c.parent.dispatchEvent(mouseEvent);
            }
        }));

        var gremlinHorde = gremlins.createHorde().gremlin(gremlins.species.clicker().clickTypes(['click']));

        const customLogger = {
            log(msg) { /* .. */ },
            info(msg) { /* .. */ },
            warn(msg) { /* .. */ },
            error(msg) { /* .. */ }
        };
        gremlinHorde.logger(customLogger);

        return gremlinHorde;
    }
}

